import { createApp } from "vue";

import ConfirmModal from "@/shared/components/atoms/ConfirmModal.vue";

import { ConfirmModal as _ConfirmModal } from "@/shared/model/confirm-modal";

export default function useConfirmModal() {
    const openModal = (options: _ConfirmModal) => {
        const root = document.createElement("div");
        document.body.appendChild(root);

        const component = createApp(ConfirmModal, {
            ...options,
            onClose: () => {
                component.unmount();
                root.remove();
            },
        });

        component.mount(root);
    };

    return {
        openModal,
    };
}
